// @flow
import Container from './Container'
import Cookie from '../components/utils/Cookie'
import ExternalService from '../components/utils/ExternalService'
import request from '../components/utils/Request'

const RELOAD_INTERVAL_MS = 120000

class InboxContainer extends Container {
  handleLogoutClick: Function

  constructor (options: Object) {
    super()
    this.state = {
      inbox: {},
      isLoading: false
    }
    this.options = options
    this.emailRefreshingInterval = null
    this.handleLogoutClick = this.handleLogoutClick.bind(this)
  }

  loadInbox () {
    const {
      config: {
        proxyOptions
      },
      layout: {
        meta: {
          inbox: {
            requiredCookies,
            serviceUrlPattern
          }
        }
      }
    } = this.options

    if (this.shouldProcessInboxRequest(requiredCookies)) {
      const serviceHelper = new ExternalService(proxyOptions)
      const serviceUri = serviceHelper.getServiceUrl(serviceUrlPattern)

      this.loadInboxForFirstTime(serviceUri)
      this.startPeriodicallyLoadingInbox(serviceUri)
    }
  }

  shouldProcessInboxRequest (requiredCookies: Array<string>) {
    let shouldProcessInboxRequest = true
    if (requiredCookies && requiredCookies.length > 0) {
      const cookieHandler = new Cookie()
      if (Object.keys(cookieHandler.cookieJar).length > 0) {
        for (const cookieName of requiredCookies) {
          if (!cookieHandler.isSet(cookieName)) {
            shouldProcessInboxRequest = false
            break
          }
        }
      }
    } else {
      shouldProcessInboxRequest = false
    }
    return shouldProcessInboxRequest
  }

  loadInboxForFirstTime (serviceUri: string) {
    this.setState({
      isLoading: true
    })
    this.sendRequest(serviceUri).then(inbox => {
      this.setState({
        inbox,
        isLoading: false
      })
    }).catch(() => {
      this.setState({
        isLoading: false
      })
    })
  }

  startPeriodicallyLoadingInbox (serviceUri: string) {
    this.emailRefreshingInterval = setInterval(() => {
      this.sendRequest(serviceUri).then(inbox => {
        this.setState({
          inbox
        })
      }).catch(() => {
      })
    }, RELOAD_INTERVAL_MS)
  }

  sendRequest (serviceUri: string): Promise<Object> {
    return new Promise((resolve, reject) => {
      request({
        url: serviceUri,
        withCredentials: true
      }).then(response => {
        const inbox = (typeof response.data === 'object') ? response.data : {}
        return resolve(inbox)
      }).catch(error => {
        return reject(error)
      })
    })
  }

  handleLogoutClick (event: Object) {
    this.setState({
      isLoading: true
    })

    const {
      layout: {
        meta: {
          inbox: {
            xhrLogoutUri
          }
        }
      }
    } = this.options
    clearInterval(this.emailRefreshingInterval)
    const eventTargetUri = event.target.getAttribute('href')
    this.sendLogoutRequest(xhrLogoutUri).then(() => {
      this.loadInbox()
    }).catch(() => {
      document.location.href = eventTargetUri
      this.setState({
        isLoading: false
      })
    })
  }

  sendLogoutRequest (logoutUri: string): Promise<void> {
    return new Promise((resolve, reject) => {
      request({
        url: logoutUri,
        withCredentials: true
      }).then(() => {
        return resolve()
      }).catch(error => {
        return reject(error)
      })
    })
  }
}

export default InboxContainer
